import { render, staticRenderFns } from "./TicketSingleLine.vue?vue&type=template&id=96a96082&scoped=true&"
import script from "./TicketSingleLine.vue?vue&type=script&lang=js&"
export * from "./TicketSingleLine.vue?vue&type=script&lang=js&"
import style0 from "./TicketSingleLine.vue?vue&type=style&index=0&id=96a96082&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96a96082",
  null
  
)

export default component.exports